import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlSize } from '@common/classes/control-size';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@fortawesome/angular-fontawesome";
import * as i3 from "@ngx-translate/core";
const _c0 = function () {
  return ["far", "square"];
};
const _c1 = function (a0) {
  return {
    "text-muted": a0
  };
};
function CheckboxComponent_fa_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(2, _c0))("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r0.disabled));
  }
}
const _c2 = function () {
  return ["far", "check-square"];
};
function CheckboxComponent_fa_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(2, _c2))("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r1.disabled));
  }
}
function CheckboxComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function CheckboxComponent_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.internalClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r2.label));
  }
}
const _c3 = function (a0) {
  return {
    "margin-top": a0
  };
};
const _c4 = function (a0, a1) {
  return [a0, a1];
};
const noop = () => {};
export class CheckboxComponent {
  get value() {
    return this._value;
  }
  set value(v) {
    if (v !== this._value) {
      this._value = v;
      this.onChangeCallback(v);
    }
  }
  constructor() {
    this.size = ControlSize.normal;
    this.color = 'primary';
    this.disabled = false;
    this._value = false;
    this._disabled = false;
    this.onTouchedCallback = noop;
    this.onChangeCallback = noop;
    this.internalClick = () => {
      if (!this.disabled) {
        if (this.click) {
          this.value = this.click();
        } else {
          this.value = this.value === true ? false : true;
        }
      }
    };
  }
  onBlur() {
    this.onTouchedCallback();
  }
  writeValue(value) {
    if (value !== this._value) {
      this._value = value;
    }
  }
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this._disabled = isDisabled;
  }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) {
  return new (t || CheckboxComponent)();
};
CheckboxComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: CheckboxComponent,
  selectors: [["app-checkbox"]],
  inputs: {
    size: "size",
    color: "color",
    disabled: "disabled",
    label: "label",
    click: "click"
  },
  features: [i0.ɵɵProvidersFeature([{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CheckboxComponent,
    multi: true
  }])],
  decls: 5,
  vars: 13,
  consts: [[3, "ngClass"], [1, "checkbox", 3, "ngClass", "click"], [3, "icon", "ngClass", 4, "ngIf"], ["class", "checkbox-label", 3, "click", 4, "ngIf"], [3, "icon", "ngClass"], [1, "checkbox-label", 3, "click"]],
  template: function CheckboxComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
      i0.ɵɵlistener("click", function CheckboxComponent_Template_span_click_1_listener() {
        return ctx.internalClick();
      });
      i0.ɵɵtemplate(2, CheckboxComponent_fa_icon_2_Template, 1, 5, "fa-icon", 2);
      i0.ɵɵtemplate(3, CheckboxComponent_fa_icon_3_Template, 1, 5, "fa-icon", 2);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(4, CheckboxComponent_div_4_Template, 3, 3, "div", 3);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵclassMapInterpolate1("checkbox-container ", ctx.size, "");
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c3, !!ctx.label));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c4, ctx.size, "text-" + ctx.color));
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", !ctx.value);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.value);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.label);
    }
  },
  dependencies: [i1.NgClass, i1.NgIf, i2.FaIconComponent, i3.TranslatePipe],
  styles: ["[_nghost-%COMP%] {\n  display: block;\n  font-size: 1.25rem;\n}\n\nlabel[_ngcontent-%COMP%] {\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.col-form-label[_ngcontent-%COMP%] {\n  font-size: 0.875rem;\n}\n\n.checkbox-container[_ngcontent-%COMP%] {\n  font-size: 1rem;\n  line-height: 1rem;\n}\n.checkbox-container.margin-top[_ngcontent-%COMP%] {\n  margin-top: 1.6rem;\n}\n.checkbox-container.sm[_ngcontent-%COMP%] {\n  font-size: 1rem;\n  line-height: 1rem;\n}\n.checkbox-container.lg[_ngcontent-%COMP%] {\n  font-size: 1.25rem;\n  line-height: 1.25rem;\n}\n.checkbox-container[_ngcontent-%COMP%]   .checkbox-label[_ngcontent-%COMP%] {\n  display: inline;\n  padding-left: 0.5rem;\n  cursor: pointer;\n}\n.checkbox-container[_ngcontent-%COMP%]   .checkbox[_ngcontent-%COMP%] {\n  display: inline;\n  width: 1.25rem;\n  cursor: pointer;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
});